import authStore from '@/store/modules/auth'
import userStore from '@/store/modules/user'

export default function (to) {
	const Hubspot = (window._hsq = window._hsq || [])
	Hubspot.push(['setPath', to.path])
	Hubspot.push(['trackPageView'])
	const isUserAuthenticated = authStore.state.isAuthenticated
	if (isUserAuthenticated) {
		const userEmail = userStore.state.email
		if (userEmail) {
			Hubspot.push(["identify", {
				email: userEmail,
			}]);
		}
	}
	return true
}
